import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { MoireMark } from "@/components/MoireLogo";

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => { if (user === false) navigate("/signin"); }, [user, navigate]);
  if (!user) return null;

  return (
    <div className="max-w-2xl mx-auto px-5 md:px-8 py-20">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
        <div className="flex items-center gap-5">
          <div className="h-16 w-16 rounded-full border border-[#C8A97E]/40 flex items-center justify-center">
            <MoireMark size={30} />
          </div>
          <div>
            <p className="font-sans text-[10px] tracking-luxe uppercase text-[#8A8170]">Profile</p>
            <h1 className="font-serif text-3xl text-[#F5F2EA]">{user.name}</h1>
            <p className="font-sans text-sm text-[#8A8170]">{user.email}</p>
          </div>
        </div>

        <div className="gold-line my-10" />

        <div className="space-y-6">
          <Row label="Style preferences" value="Coming soon — tell MOIRÉ your fits and favourite colours." />
          <Row label="Saved looks" value="View your styled pairings." action={() => navigate("/saved")} actionLabel="Open" />
          <Row label="Wardrobe" value="Photograph and save your own pieces (soon)." />
        </div>

        <button onClick={() => { logout(); navigate("/"); }} data-testid="profile-logout"
          className="mt-12 border border-[#F5F2EA]/15 px-8 py-3 font-sans text-xs tracking-wider uppercase hover:border-[#C8A97E] transition-colors">
          Sign Out
        </button>
      </motion.div>
    </div>
  );
}

function Row({ label, value, action, actionLabel }) {
  return (
    <div className="flex items-center justify-between border-b border-[#F5F2EA]/10 pb-5">
      <div>
        <div className="font-sans text-[10px] tracking-luxe uppercase text-[#8A8170]">{label}</div>
        <div className="font-sans text-sm text-[#F5F2EA]/80 mt-1">{value}</div>
      </div>
      {action && (
        <button onClick={action} className="font-sans text-xs tracking-wider uppercase text-[#C8A97E] hover:text-[#E5C293] shrink-0 ml-4">{actionLabel}</button>
      )}
    </div>
  );
}
